module.exports = __webpack_public_path__ + "app-static/img/icon_shouji.7cf000f9.png";